import $ from 'jquery';
import fitvids from 'fitvids';
import GroupedContent from 'grouped-content';

export default class RTE {
  constructor(instance) {
    this.$el = $(instance.el);
    this.$select = $('.select-wrapper select', this.$el);
    this.$select.on('change', () => this.updateOption());

    const selects = this.$el.find('select');
    selects.each((index, select) => {
      if (!$(select).parent('.select-wrapper').length) {
        $(select).wrap('<div class="select-wrapper" />').parent().prepend('<span class="selected-text"></span>');
      }
      this.updateOption(null, select);
    });

    fitvids(this.$el);
    this.setupTabs();
  }

  setupTabs() {
    this.tabs = new GroupedContent(document.querySelector('.rte'), { layout: 'tabs' });
  }

  updateOption(e, selector) {
    const select = e ? $(e.target) : $(selector);
    const newOption = select.find('option:selected').text();

    select.siblings('.selected-text').text(newOption);
  }

  unload() {
    this.tabs.unload();
    this.$select.off('change');
  }
}
